import { render } from "./VideoCropper.vue?vue&type=template&id=00d3706e&scoped=true"
import script from "./VideoCropper.vue?vue&type=script&lang=js"
export * from "./VideoCropper.vue?vue&type=script&lang=js"

import "./VideoCropper.vue?vue&type=style&index=0&id=00d3706e&scoped=true&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d3706e"]])

export default __exports__